<header class="hero-section">
  <div class="hero-content wrap">
    <div class="badge">Get in Touch</div>
    <h1 class="hero-title">
      Let’s build something <span class="text-accent">great</span>
    </h1>
    <p class="hero-lead">
      Whether you have a question about Angularize or want to collaborate, we’re
      here to help.
    </p>
  </div>
  <div class="hero-bg-glow"></div>
</header>

<main class="wrap section">
  <div class="contact-grid">
    <mat-card class="contact-card shadow-sm">
      <div class="card-intro">
        <h2>Contact Us</h2>
        <p>We usually respond within 24–48 hours.</p>
      </div>

      <form
        [formGroup]="contactForm"
        (ngSubmit)="onSubmit()"
        class="contact-form"
      >
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Full Name</mat-label>
            <input
              matInput
              formControlName="fullName"
              placeholder="Your name"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Email Address</mat-label>
            <input
              matInput
              formControlName="email"
              placeholder="email@example.com"
            />
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Company (Optional)</mat-label>
          <input
            matInput
            formControlName="company"
            placeholder="Organization name"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Reason for Contact</mat-label>
          <mat-select formControlName="reason">
            <mat-option *ngFor="let r of reasons" [value]="r">{{
              r
            }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="message-field">
          <mat-label>Your Message</mat-label>
          <textarea
            matInput
            rows="4"
            formControlName="message"
            placeholder="How can we help?"
          ></textarea>
        </mat-form-field>

        <div class="file-upload-wrapper">
          <input
            type="file"
            #fileInput
            accept="application/pdf"
            style="display: none"
            (change)="onFileSelected($event)"
          />
          <div class="file-info" (click)="fileInput.click()">
            <span class="file-text">{{
              selectedFileName || "Attach Resume / Brief (PDF)"
            }}</span>
            <button type="button" class="file-btn">Choose File</button>
          </div>
        </div>

        <div class="consent-wrapper">
          <mat-checkbox formControlName="consent" class="consent-check">
            I agree to the
            <a
              href="https://pythrust.com/privacy-policy"
              target="_blank"
              class="inline-link"
              >Privacy Policy</a
            >
            and
            <a
              href="https://pythrust.com/terms-and-conditions"
              target="_blank"
              class="inline-link"
              >Terms of Service</a
            >.
          </mat-checkbox>

          <mat-error
            *ngIf="
              contactForm.get('consent')?.touched &&
              contactForm.get('consent')?.invalid
            "
            class="consent-error"
          >
            Please accept the terms to continue.
          </mat-error>
        </div>

        <button
          mat-flat-button
          class="submit-btn"
          type="submit"
          [disabled]="isLoading"
        >
          <span *ngIf="!isLoading">Send Message</span>

          <div
            *ngIf="isLoading"
            style="display: flex; align-items: center; gap: 10px"
          >
            <mat-spinner diameter="24" color="accent"></mat-spinner>
            <span>Sending...</span>
          </div>
        </button>
      </form>
    </mat-card>

    <aside class="faq-section">
      <div class="eyebrow">Frequently Asked Questions ❓</div>

      <div class="faq-list">
        <details *ngFor="let faq of faqs" class="faq-item">
          <summary>{{ faq.q }}</summary>
          <p>{{ faq.a }}</p>
        </details>
      </div>

      <div class="direct-contact-box">
        <h4>Need immediate help?</h4>
        <p>Reach Ankit's team directly at:</p>
        <a href="mailto:angularize.dev@gmail.com" class="email-link"
          >angularize.dev&#64;gmail.com</a
        >
      </div>
    </aside>
  </div>

  <section class="map-section wrap">
    <div class="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d876.9863388452653!2d77.09661125952455!3d28.451063601692724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d196a9219452f%3A0x2b7db4e11e0c29d1!2sWeWork%20Two%20Horizon%20Centre%20-%20Coworking%20%26%20Office%20Space%20in%20Golf%20Course%20Road%2C%20Gurugram!5e0!3m2!1sen!2sin!4v1771577652241!5m2!1sen!2sin"
        width="100%"
        height="450"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
      <!-- <div class="map-overlay">
        <div class="overlay-card">
          <strong>WeWork Two Horizon</strong>
          <p>DLF Phase 5, Gurugram</p>
          <a
            href="https://share.google/NQIROBPgHpDNgAoAY"
            target="_blank"
            class="map-link"
            >Open in Google Maps ↗</a
          >
        </div>
      </div> -->
    </div>
  </section>
</main>

<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner diameter="40"></mat-spinner>
  <br />
  <p>Submitting your details...</p>
</div>
